class ObjectHelper {
	// посчитать кол-во элементов в объекте
	static count(obj) {
		return Object.keys(obj).length;
	}

	static join(obj, splitter) {
		return Object.keys(obj).join(splitter);
	}

	// если уже есть элемент с указанным ключом, то удаляет его, иначе добавляет
	static toggleData(obj, key) {
		key in obj ? delete obj[key] : obj[key] = true;
		return obj;
	}
}

export default ObjectHelper;


// WEBPACK FOOTER //
// ./src/app/helpers/ObjectHelper.js